import { z } from 'zod';

import { uuidValidator } from '../../validators';

export const GenerateShortAnswerQuestionResponseSchema = z.object({
  questionId: z
    .string()
    .uuid()
    .describe('Unique ID for this question session for context preservation'),
  id: uuidValidator.describe('The ID of the book used for the question'),
  question: z.string().describe('The generated short-answer question'),
});

export type IGenerateShortAnswerQuestionResponseDto = z.infer<
  typeof GenerateShortAnswerQuestionResponseSchema
>;
